import { render, staticRenderFns } from "./MegaMenuCategories.vue?vue&type=template&id=61ab4f54&scoped=true&"
import script from "./MegaMenuCategories.vue?vue&type=script&lang=ts&"
export * from "./MegaMenuCategories.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenuCategories.vue?vue&type=style&index=0&id=61ab4f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab4f54",
  null
  
)

export default component.exports